import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DefineCapacityPopup = ({
  open,
  onClose,
  onSubmit,
  centerData, // Receive center data
  initialData = {},
}) => {
  const [capacityForm, setCapacityForm] = useState({
    ticket_accept_limit: "",
    qr_id: "",
    duration: "",
  });

  // Auto-fill form when centerData changes
  useEffect(() => {
    if (centerData) {
      setCapacityForm({
        ticket_accept_limit: centerData.ticket_accept_limit || "",
        qr_id: centerData.qrCode || "",
        duration: initialData.duration || "",
      });
    }
  }, [centerData, initialData.duration]);

  const handleChange = (field, value) => {
    setCapacityForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = () => {
    onSubmit(capacityForm);
  };

  if (!open) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.5)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <Box
        sx={{
          backgroundColor: "white",
          padding: "20px",
          borderRadius: "8px",
          width: "400px",
          position: "relative",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <IconButton
          onClick={onClose}
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
          }}
          aria-label="close"
        >
          <CloseIcon />
        </IconButton>

        <Typography variant="h6" sx={{ marginBottom: "20px" }}>
          Define Center Capacity
        </Typography>

        <Box sx={{ marginBottom: "15px" }}>
          <TextField
            fullWidth
            label="Set Center Limit"
            variant="outlined"
            type="number"
            value={capacityForm.ticket_accept_limit}
            onChange={(e) =>
              handleChange("ticket_accept_limit", e.target.value)
            }
          />
        </Box>

        <Box sx={{ marginBottom: "15px" }}>
          <TextField
            fullWidth
            label="Enter INA"
            variant="outlined"
            value={capacityForm.qr_id}
            onChange={(e) => handleChange("qr_id", e.target.value)}
          />
        </Box>

        <Box sx={{ marginBottom: "20px" }}>
          <FormControl fullWidth>
            <InputLabel id="duration-label">Select Duration</InputLabel>
            <Select
              labelId="duration-label"
              value={capacityForm.duration}
              label="Select Duration"
              onChange={(e) => handleChange("duration", e.target.value)}
              MenuProps={{
                disablePortal: true,
                PaperProps: {
                  style: {
                    zIndex: 13001,
                  },
                },
              }}
            >
              {[
                "1 day",
                "3 days",
                "7 days",
                "15 days",
                "30 days",
                "1 week",
                "1 month",
                "6 months",
                "1 year",
              ].map((option) => (
                <MenuItem
                  key={option}
                  value={option}
                  sx={{
                    whiteSpace: "normal",
                  }}
                >
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Button
          variant="contained"
          sx={{ backgroundColor: "#303F9F", color: "white" }}
          onClick={handleSubmit}
          disabled={!capacityForm.ticket_accept_limit}
        >
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default DefineCapacityPopup;
